import { API_BASE_URL } from "../config";
import { saveReturnTo } from "./session";

// The app has ~28 call sites doing raw `fetch(`${API_BASE_URL}/...`)` with no
// shared API client. Rather than touch every call site to attach the auth
// token, patch window.fetch once here (imported first in index.js) so every
// request to the backend gets the bearer token, and a 401 anywhere logs the
// user out instead of silently failing.
const originalFetch = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url || "";

  if (!url.startsWith(API_BASE_URL)) {
    return originalFetch(input, init);
  }

  let token;
  try {
    const user = JSON.parse(sessionStorage.getItem("user"));
    token = user?.token;
  } catch {
    token = undefined;
  }

  const headers = new Headers(init.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const response = await originalFetch(input, { ...init, headers });

  if (response.status === 401) {
    try {
      saveReturnTo(JSON.parse(sessionStorage.getItem("user"))?.id);
    } catch {
      // No saved session to remember.
    }
    sessionStorage.clear();
    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }
  }

  return response;
};
